import { MEDIA } from "./business";

// Detailed product catalog for /products list + /products/:slug detail pages
export const PRODUCTS = [
  {
    slug: "passenger-elevators",
    icon: "Users",
    title: "Passenger Elevators",
    tagline: "For residential towers, commercial complexes & hotels",
    tag: "Commercial · Residential",
    image: MEDIA.productElevator,
    short:
      "Smooth, whisper-quiet passenger lifts with MRL (Machine Room Less) and traction options. Capacities from 6 to 20 persons.",
    long:
      "Vila's passenger elevators are engineered for high-rise buildings across residential apartments, offices, hotels and mixed-use complexes. Every unit is powered by an industry-leading intelligent controller paired with the Vila web app — so building managers get real-time monitoring, instant fault alerts and remote diagnostics from anywhere. Our machine-room-less (MRL) traction systems deliver smooth, energy-efficient rides while occupying minimal shaft space.",
    features: [
      "Intelligent controller",
      "Web-app monitoring — real-time health & alerts",
      "MRL & traction drive options",
      "VVVF energy-efficient control",
      "Stainless steel / bronze / mirror-finish cabin",
      "Automatic Rescue Device (ARD)",
      "Fireman switch & emergency lighting",
      "Optional destination-dispatch system",
    ],
    specs: {
      Capacity: "408 – 1600 kg (6 – 20 persons)",
      Speed: "1.0 – 2.5 m/s",
      Floors: "Up to 30 floors",
      Drive: "MRL / Traction / Gearless",
      Controller: "Intelligent controller (web-app monitored)",
      "Door Type": "Auto-sliding, center / side opening",
      Certification: "IS 14665, EN 81-20/50 compliant",
    },
    useCases: [
      "Residential high-rises & apartments",
      "Corporate offices & IT parks",
      "Hotels & serviced apartments",
      "Retail malls & showrooms",
    ],
    seoTitle:
      "Passenger Elevators in Bangalore | MRL & Traction Lifts | Vila Elevators",
    seoDesc:
      "Vila Elevators manufactures MRL passenger elevators in Bangalore for residential towers, offices and hotels. IS 14665 certified, VVVF drive, 6–20 person capacities.",
    keywords:
      "passenger elevator bangalore, MRL elevator manufacturer, traction lift, residential elevator karnataka, commercial passenger lift",
  },
  {
    slug: "home-lifts",
    icon: "Home",
    title: "Home Lifts",
    tagline: "Compact luxury for villas, duplexes & private homes",
    tag: "Residential Villas",
    image: MEDIA.homeLift,
    short:
      "Compact, elegant lifts designed for private homes, duplexes and villas. Hydraulic and traction variants available.",
    long:
      "Our home lifts are purpose-built for private residences — silent, compact, and designed to complement premium interiors. Compact shaft footprint means you can retrofit into existing villas. Hydraulic variants offer battery backup during power outages.",
    features: [
      "Compact 900mm × 1100mm shaft footprint",
      "Silent (<50 dB) operation",
      "Intelligent controller",
      "Web-app monitoring — check lift status remotely",
      "Hydraulic or gearless traction drives",
      "Battery backup for hydraulic models",
      "Custom cabin: wood veneer, glass, mirror",
      "Touch-screen and app control options",
    ],
    specs: {
      Capacity: "180 – 400 kg (2 – 5 persons)",
      Speed: "0.15 – 0.5 m/s",
      Floors: "Up to 6 floors",
      Drive: "Hydraulic / Gearless MRL",
      "Shaft Size": "From 900 × 1100 mm",
      "Power Supply": "Standard 220V single-phase available",
    },
    useCases: [
      "Independent villas & bungalows",
      "Duplex apartments",
      "Small boutique hotels",
      "Retrofit for elderly / accessibility",
    ],
    seoTitle:
      "Home Lifts in Bangalore | Villa Elevator | Home Elevator Manufacturer | Vila",
    seoDesc:
      "Vila home lifts for villas, duplexes and homes in Bangalore. Compact shaft, silent operation, hydraulic & MRL options. Retrofit-friendly for existing homes.",
    keywords:
      "home lift bangalore, villa elevator, home elevator manufacturer, compact residential lift, small home lift karnataka",
  },
  {
    slug: "freight-elevators",
    icon: "Package",
    title: "Freight / Cargo Elevators",
    tagline: "Heavy-duty vertical transport for industries",
    tag: "Industrial",
    image: MEDIA.freightEntrance,
    short:
      "Heavy-duty goods lifts for factories, warehouses, and industrial plants. Capacities up to 5000+ kg.",
    long:
      "Vila freight elevators handle heavy cargo, pallet trucks, and forklift loads with reinforced platforms and industrial-grade motors. Perfect for manufacturing plants, cold storage, and multi-level warehouses.",
    features: [
      "Reinforced steel platform (checker-plate)",
      "Trolley-friendly flat threshold",
      "Multi-directional opening options",
      "Heavy-duty guide rails",
      "Optional weather-sealed doors for outdoor use",
      "Overload sensor & emergency-stop",
    ],
    specs: {
      Capacity: "1000 – 5000+ kg",
      Speed: "0.25 – 1.0 m/s",
      Floors: "Up to 15 floors",
      Drive: "Gearless / Geared traction",
      "Door Options": "Manual, semi-auto, auto vertical bi-parting",
      Compliance: "IS 14665 Part 2",
    },
    useCases: [
      "Manufacturing plants & factories",
      "Warehouses & distribution centers",
      "Cold storage facilities",
      "Automotive service centers",
    ],
    seoTitle: "Freight & Cargo Elevators | Industrial Goods Lift | Vila Elevators Bangalore",
    seoDesc:
      "Heavy-duty freight elevators from Vila — up to 5000+ kg for factories, warehouses, cold storage. Reinforced platforms and industrial-grade drives.",
    keywords:
      "freight elevator bangalore, cargo lift, goods lift manufacturer, industrial elevator, warehouse lift karnataka",
  },
  {
    slug: "hospital-lifts",
    icon: "HeartPulse",
    title: "Hospital / Stretcher Lifts",
    tagline: "Extra-wide cabins for healthcare facilities",
    tag: "Healthcare",
    image: MEDIA.hospitalLobby,
    short:
      "Wide-cabin lifts engineered for hospitals — stretcher-friendly with antibacterial finishes and priority controls.",
    long:
      "Every second matters in a hospital. Vila hospital lifts feature extra-wide, stretcher-length cabins, antibacterial cabin surfaces, and priority-key overrides so medical staff always have precedence during emergencies.",
    features: [
      "Extra-wide (up to 2400mm depth) cabin",
      "Antibacterial powder-coat cabin finishes",
      "Priority-key medical override",
      "Emergency battery-backed rescue (ARD)",
      "Voice announcement & braille buttons",
      "Silent operation for patient comfort",
    ],
    specs: {
      Capacity: "1000 – 1800 kg (13 – 24 persons)",
      Speed: "1.0 – 2.0 m/s",
      "Cabin Depth": "2100 – 2400 mm",
      Drive: "MRL / Traction",
      Certification: "IS 14665, hospital-grade compliance",
      Doors: "Auto sliding, telescopic side-opening",
    },
    useCases: [
      "Hospitals & multi-specialty clinics",
      "Nursing homes & assisted living",
      "Rehabilitation centers",
      "Medical research facilities",
    ],
    seoTitle: "Hospital Lifts & Stretcher Elevators | Vila Elevators Bangalore",
    seoDesc:
      "Vila hospital lifts with extra-wide stretcher cabins, antibacterial finish and priority controls. Trusted by hospitals across South India.",
    keywords:
      "hospital lift bangalore, stretcher elevator, medical lift manufacturer, healthcare elevator karnataka",
  },
  {
    slug: "escalators",
    icon: "MoveUp",
    title: "Escalators",
    tagline: "High-flow escalators for malls, transit & offices",
    tag: "Commercial · Transit",
    image: MEDIA.productEscalator,
    short:
      "High-flow escalators for malls, metros, airports and public buildings. Indoor and outdoor grade.",
    long:
      "Vila escalators are built for continuous heavy-duty operation. Engineered for shopping malls, metro stations, airports and public transit hubs — with energy-saving standby mode and anti-slip serrated steps.",
    features: [
      "30° / 35° incline options",
      "Energy-saving standby mode (stops when idle)",
      "Anti-slip serrated aluminium steps",
      "LED handrail & step-edge lighting",
      "Emergency stop & safety brush skirt",
      "Indoor and outdoor (IP-rated) variants",
    ],
    specs: {
      Incline: "30° or 35°",
      "Step Width": "600 / 800 / 1000 mm",
      Speed: "0.5 m/s (adjustable)",
      "Rise Height": "Up to 8 m single flight",
      Capacity: "4,500 – 9,000 persons/hour",
      Certification: "EN 115 compliant",
    },
    useCases: [
      "Shopping malls & retail",
      "Metro & railway stations",
      "Airports & bus terminals",
      "Multi-level office lobbies",
    ],
    seoTitle: "Escalator Manufacturer in Bangalore | Vila Elevators & Escalators",
    seoDesc:
      "Vila escalators for malls, metros, airports and offices. 30°/35° incline, energy-saving standby, EN 115 compliant. Manufactured in Bangalore.",
    keywords:
      "escalator manufacturer bangalore, mall escalator, metro escalator, commercial escalator karnataka",
  },
  {
    slug: "moving-walkways",
    icon: "MoveRight",
    title: "Moving Walkways",
    tagline: "Horizontal & inclined transit for airports & malls",
    tag: "Airports · Transit",
    image: MEDIA.productEscalator,
    short:
      "Horizontal and inclined moving walkways — engineered for long-run transit environments.",
    long:
      "Move large volumes of pedestrians efficiently across airports, transit hubs, and expansive retail floors. Vila's moving walkways come in horizontal and inclined variants with extended-length capabilities.",
    features: [
      "Flat & inclined (10° / 12°) variants",
      "Extended run lengths (up to 100m)",
      "Weather-sealed outdoor grade",
      "Trolley-friendly for airports",
      "Energy-saving standby",
      "Anti-slip pallet steps",
    ],
    specs: {
      Type: "Horizontal / 10° / 12° inclined",
      "Pallet Width": "800 – 1400 mm",
      Speed: "0.5 – 0.65 m/s",
      Length: "Up to 100 m",
      Capacity: "Up to 9,000 persons/hour",
      Certification: "EN 115",
    },
    useCases: [
      "Airport terminals",
      "Metro stations & transit hubs",
      "Large shopping malls",
      "Convention centers & expo halls",
    ],
    seoTitle: "Moving Walkways & Travelators | Vila Elevators Bangalore",
    seoDesc:
      "Vila moving walkways and travelators for airports, metros and large malls. Horizontal & inclined variants, extended lengths, weather-sealed.",
    keywords:
      "moving walkway bangalore, travelator manufacturer, airport walkway, inclined walkway, horizontal walkway india",
  },
];

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
